import script from "./ChatPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatPreview.vue?vue&type=script&setup=true&lang=ts"

import "./ChatPreview.vue?vue&type=style&index=0&id=446455aa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-446455aa"]])

export default __exports__